<template>
  <v-tooltip bottom :value="loading" :disabled="!text">
    <template v-slot:activator="{ on }">
      <v-btn
        @click.stop="$emit('clicked')"
        class="hidden-md-and-down ma-1"
        fab
        small
        outlined
        color="primary"
        v-on="on"
        :disabled="disabled || loading"
        :loading="loading"
        :to="to"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
      <v-btn
        @click.stop="$emit('clicked')"
        class="hidden-lg-and-up ma-0 pa-0"
        text
        icon
        small
        color="primary"
        v-on="on"
        :disabled="disabled || loading"
        :loading="loading"
        :to="to"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ $t(text) }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ["icon", "text", "small", "disabled", "loading", "to"]
};
</script>